import React from "react";

import { Text } from "triider-components";

import SVG from "components/SVG";

import { PaymentMethods } from "config/shared";

import * as s from "./styles";

export default function PaymentMethodSelector({
  paymentMethodSelected,
  setPaymentMethod
}) {
  const DOC_SELECTED = paymentMethodSelected === PaymentMethods.DOC;
  const CREDIT_CARD_SELECTED =
    paymentMethodSelected === PaymentMethods.CREDIT_CARD;

  function Check() {
    return (
      <s.CheckWrapper>
        <SVG.Check color="white" />
      </s.CheckWrapper>
    );
  }

  return (
    <s.Container>
      <s.Selector
        selected={DOC_SELECTED}
        onClick={() => setPaymentMethod(PaymentMethods.DOC)}
      >
        <Check />
        <SVG.Doc color={s.getColor(DOC_SELECTED)} />
        <Text>Desconto no doc</Text>
      </s.Selector>
      <s.Selector
        selected={CREDIT_CARD_SELECTED}
        onClick={() => setPaymentMethod(PaymentMethods.CREDIT_CARD)}
      >
        <Check />
        <SVG.CreditCard color={s.getColor(CREDIT_CARD_SELECTED)} />
        <Text>Cartão de crédito</Text>
        <Text size="12">via link de pagamento</Text>
      </s.Selector>
    </s.Container>
  );
}
